(() => {
  const ctaModules = document.querySelectorAll('.orb-section');
  if (!ctaModules.length) return;

  const orbObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        orbObserver.unobserve(entry.target);
        initOrbSection(entry.target);
      });
    },
    { rootMargin: '200px' },
  );

  ctaModules.forEach((el) => orbObserver.observe(el));

  function initOrbSection(parent) {
    const app = parent.querySelector('.orb-section__app');
    if (!app) return;

    // ===================== CONFIG =====================
    const isMobile = window.matchMedia('(pointer:coarse)').matches;
    const DPR = Math.min(window.devicePixelRatio || 1, isMobile ? 1.25 : 1.5);

    const COUNT = 10000;
    const ORB_RADIUS = 1.0;
    const POINT_SIZE = 0.006;
    const COLOR = '#ffffff';

    const ROT_RANGE = -Math.PI * 2;
    const ROT_DAMP = 0.15;
    // ==================================================

    // --- Scene ---
    const scene = new THREE.Scene();

    // --- Camera ---
    const camera = new THREE.PerspectiveCamera(40, 1, 0.1, 1000);
    camera.position.z = 3;

    // --- Renderer ---
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(DPR);
    app.appendChild(renderer.domElement);

    // ===================== PARTICLE ORB =====================
    function makeOrbPoints(count, radius, pointSize, colorHex) {
      const positions = new Float32Array(count * 3);

      for (let i = 0; i < count; i++) {
        const u = Math.random();
        const v = Math.random();

        const theta = 2 * Math.PI * u;
        const cosPhi = 2 * v - 1;
        const sinPhi = Math.sqrt(1 - cosPhi * cosPhi);

        const x = radius * sinPhi * Math.cos(theta);
        const y = radius * cosPhi;
        const z = radius * sinPhi * Math.sin(theta);

        const i3 = i * 3;
        positions[i3] = x;
        positions[i3 + 1] = y;
        positions[i3 + 2] = z;
      }

      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

      const material = new THREE.PointsMaterial({
        size: pointSize,
        sizeAttenuation: true,
        transparent: true,
        depthWrite: false,
        color: new THREE.Color(colorHex),
      });

      return new THREE.Points(geometry, material);
    }

    const orbGroup = new THREE.Group();
    scene.add(orbGroup);

    const orb = makeOrbPoints(COUNT, ORB_RADIUS, POINT_SIZE, COLOR);
    orbGroup.add(orb);

    // ===================== SCROLL → ROTATION =====================
    let targetRotX = 0;
    let currentRotX = 0;

    const clamp01 = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);

    const getSectionScrollProgress = () => {
      const rect = parent.getBoundingClientRect();
      const vh = window.innerHeight;

      const total = rect.height + vh;
      const progressed = vh - rect.top;

      return clamp01(progressed / total);
    };

    const updateTargetFromScroll = () => {
      targetRotX = getSectionScrollProgress() * ROT_RANGE;
    };

    window.addEventListener('scroll', updateTargetFromScroll, { passive: true });
    window.addEventListener('resize', updateTargetFromScroll);
    updateTargetFromScroll();

    // ===================== RESIZE =====================
    const resizeRenderer = () => {
      const rect = app.getBoundingClientRect();
      const w = Math.max(1, rect.width);
      const h = Math.max(1, rect.height);

      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h, false);
    };

    window.addEventListener('resize', debounce(resizeRenderer, 200));
    resizeRenderer();

    // ===================== VISIBILITY =====================
    let isVisible = false;
    const visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;
      },
      { rootMargin: '100px' },
    );
    visibilityObserver.observe(parent);

    // ===================== ANIMATE =====================
    const clock = new THREE.Clock();

    function animate() {
      requestAnimationFrame(animate);
      if (!isVisible) return;

      const dt = Math.min(clock.getDelta(), 0.033);
      const k = 1 - (1 - ROT_DAMP) ** (dt * 60);

      currentRotX += (targetRotX - currentRotX) * k;
      orbGroup.rotation.x = currentRotX;

      renderer.render(scene, camera);
    }

    animate();
  }
})();
